import { Col, Row } from "antd";
import React from "react";
import { BsGlobe2 } from "react-icons/bs";
import { Domain, request } from "../../../config/API";
import renderSocialIcon from "../components/rederSocialIcons";
import ButtonBar from "./ButtonBar";
const SocialIconBar = ({
  socialLinks,
  leadEnable,
  sColor,
  downloadVcfFile,
  setShowExchangeCard,
  owner,
  isBlack,
  webLinks,
  isPreview = false,
}) => {
  const handleLinkClicked = (type) => {
    const data = { type, portalId: owner };
    request
      .post("qr/postLinkClicked", data)
      .then(async (res) => {})
      .catch((e) => {
        console.log("post click error=>", e);
      });
  };

  return (
    <div>
      <div
        className="social-links-container"
        style={{
          alignSelf: "center",
          justifyContent: "center",
          alignContent: "center",
          display: "flex",
          flexWrap: "wrap",
          flexDirection: "row",
          alignItems: "stretch",
        }}
      >
        {!isPreview && (
          <>
            {socialLinks?.map((l) => {
              return (
                <>
                  {l.link && (
                    <div
                      className="social-links"
                      onClick={() => {
                        window.open("https://" + l?.link, "_blank");
                        handleLinkClicked("sociallink");
                      }}
                      key={l._id}
                    >
                      {renderSocialIcon(l?.name, isBlack)}
                    </div>
                  )}
                </>
              );
            })}
            {webLinks?.slice(0, 1).map((l, i) => {
              return (
                <div
                  onClick={() => window.open("https://" + l?.link, "_blank")}
                  key={i}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  {l.icon ? (
                    <div
                      className="link-icon-sizes-container"
                      style={{
                        display: "flex",
                        backgroundColor: isBlack ? "black" : "white",
                        justifyContent: "center",
                        alignItems: "center",
                        overflow: "hidden",
                        borderRadius: "2rem",
                      }}
                    >
                      <i
                        className={`link-icon-sizes fas fa-${l.icon}`}
                        style={{
                          color: sColor,
                        }}
                      />
                    </div>
                  ) : l.image ? (
                    <div
                      className="link-icon-sizes-container"
                      style={{
                        display: "flex",
                        backgroundColor: isBlack ? "black" : "white",
                        justifyContent: "center",
                        alignItems: "center",
                        overflow: "hidden",
                        borderRadius: "2rem",
                      }}
                    >
                      <img
                        src={Domain + "/data/" + l?.image}
                        className="link-icon-sizes"
                        style={{
                          width: "75%",
                          height: "75%",
                        }}
                        alt="icon"
                      />
                    </div>
                  ) : (
                    <BsGlobe2
                      className="icon-sizes"
                      style={{
                        color: sColor,
                        backgroundColor: isBlack ? "black" : "white",
                      }}
                    />
                  )}
                </div>
              );
            })}
          </>
        )}
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignContent: "center",
          alignItems: "center",
          paddingBottom: "1.7rem",
        }}
      >
        <ButtonBar
          leadEnable={leadEnable}
          sColor={sColor}
          downloadVcfFile={downloadVcfFile}
          setShowExchangeCard={setShowExchangeCard}
        />
      </div>
    </div>
  );
};

export default SocialIconBar;
